<section class="check-in-mrz-page">
  <div class="check-in-mrz-page__card">
    <menu-buttons-header label="Check-in" sublabel="Adulto"></menu-buttons-header>
    <div class="check-in-mrz-page__content">
      <!-- STEP 1: Intro --------------------------------------------------->
      <ng-container *ngIf="currentStep === 'intro'">
        <div class="checkin-body">
          <p class="checkin-text">
            Para realizar el registro es necesario leer, mediante la cámara de tu móvil,
            la banda MRZ de tu documento de identidad o pasaporte.
          </p>

          <div class="mrz-card">
            <!-- Sustituye esta imagen por la tuya real -->
            <img src="/images/mrz-passport-placeholder-frame.png"
                 alt="Documento de identidad con banda MRZ"/>

            <div class="mrz-label">Banda MRZ</div>
          </div>
          <div class="button-container">
            <square-button [label]="'Leer Banda MRZ'" (click)="goToScanner()"></square-button>
          </div>
          <div class="button-container__secondary">
            <square-button [size]="'small'" [label]="'Continuar sin leer'" (click)="skipScanner()" [testId]="'check-in-mrz-skip'"></square-button>
          </div>
          <p class="checkin-disclaimer">
            No capturamos ni almacenamos imágenes de tus documentos.
            Solo leemos la banda MRZ para extraer los datos mínimos para el registro de viajeros.
          </p>
        </div>
      </ng-container>

      <!-- STEP 2: Scanner ------------------------------------------------->
      <ng-container *ngIf="currentStep === 'scanner'">
        <div class="videoOverlay" *ngIf="busy">
          <div class="spinner"></div>
        </div>
        <div class="checkin-body">
          <div class="checkin-section">
            <h3 class="checkin-subtitle">Lectura de MRZ.</h3>
            <p class="checkin-text">
              Coloca tu documento de identidad o pasaporte en un lugar bien iluminado,
              sin brillos ni sombras. Encuadra la banda MRZ dentro del recuadro y sin cortarla.
            </p>
          </div>


          <app-mrz-camera
            (mrzSuccess)="onMrzSuccess($event)"
            (mrzPartialSuccess)="onMrzPartialSuccess($event)"
            (mrzError)="onMrzError($event)"
            (mrzCapture)="onMrzCapture()">
          </app-mrz-camera>

          <div class="button-container">
            <square-button [size]="'small'" [label]="'Continuar sin leer'" (click)="skipScanner()"></square-button>
          </div>

          <div class="checkin-section__secondary">
            <h3 class="checkin-subtitle">Dónde está la banda MRZ</h3>
            <p class="checkin-text">
              <strong>Pasaporte:</strong> en la parte inferior de la página de datos, normalmente 2 líneas largas con letras y números.
            </p>
            <p class="checkin-text">
              <strong>DNI o tarjeta de identidad:</strong> en la parte trasera, normalmente 3 líneas.
            </p>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>
